import { render, staticRenderFns } from "./BearbeitenHerstellerKundenumsaetze.vue?vue&type=template&id=2922eaeb&"
import script from "./BearbeitenHerstellerKundenumsaetze.vue?vue&type=script&lang=js&"
export * from "./BearbeitenHerstellerKundenumsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports